var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9508 26.54C20.5008 26.54 17.5898 27.1038 17.5898 29.2795C17.5898 31.4562 20.5196 32.0001 23.9508 32.0001C27.4008 32.0001 30.3117 31.4364 30.3117 29.2606C30.3117 27.084 27.382 26.54 23.9508 26.54Z",
    fill: "#130F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.9476 24.467C26.2837 24.467 28.1569 22.5831 28.1569 20.2335C28.1569 17.8831 26.2837 16 23.9476 16C21.6115 16 19.7383 17.8831 19.7383 20.2335C19.7383 22.5831 21.6115 24.467 23.9476 24.467Z",
    fill: "#130F26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.0886 21.2197C33.693 18.8422 31.9209 16.707 29.6645 16.707C29.4192 16.707 29.1846 16.734 28.9554 16.78C28.9249 16.7872 28.8909 16.8025 28.873 16.8295C28.8524 16.8637 28.8676 16.9097 28.89 16.9394C29.5678 17.8958 29.9573 19.0602 29.9573 20.3102C29.9573 21.5079 29.6001 22.6246 28.9733 23.5513C28.9088 23.6467 28.9661 23.7755 29.0798 23.7953C29.2374 23.8232 29.3986 23.8376 29.5634 23.8421C31.2064 23.8854 32.6811 22.8218 33.0886 21.2197Z",
    fill: "#130F26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8094 26.8165C34.5086 26.1717 33.7824 25.7295 32.6783 25.5125C32.1572 25.3846 30.747 25.2045 29.4352 25.2288C29.4155 25.2315 29.4048 25.245 29.403 25.254C29.4003 25.2666 29.4057 25.2882 29.4316 25.3017C30.0378 25.6034 32.3811 26.9155 32.0865 29.6829C32.074 29.8027 32.1698 29.9063 32.2888 29.8883C32.8655 29.8054 34.3492 29.4848 34.8094 28.4861C35.0637 27.9584 35.0637 27.3451 34.8094 26.8165Z",
    fill: "#130F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.0451 16.78C18.8167 16.7331 18.5813 16.707 18.3359 16.707C16.0795 16.707 14.3075 18.8422 14.9128 21.2197C15.3193 22.8218 16.794 23.8854 18.4371 23.8421C18.6019 23.8376 18.7639 23.8223 18.9206 23.7953C19.0343 23.7755 19.0916 23.6467 19.0272 23.5513C18.4004 22.6237 18.0431 21.5079 18.0431 20.3102C18.0431 19.0593 18.4335 17.8949 19.1113 16.9394C19.1328 16.9097 19.1489 16.8637 19.1275 16.8295C19.1095 16.8016 19.0764 16.7872 19.0451 16.78Z",
    fill: "#130F26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3216 25.5127C14.2175 25.7297 13.4922 26.1719 13.1914 26.8167C12.9362 27.3453 12.9362 27.9586 13.1914 28.4872C13.6516 29.4851 15.1353 29.8066 15.712 29.8885C15.831 29.9065 15.926 29.8038 15.9134 29.6832C15.6188 26.9167 17.9621 25.6046 18.5692 25.3029C18.5943 25.2885 18.5996 25.2677 18.5969 25.2542C18.5951 25.2452 18.5853 25.2317 18.5656 25.2299C17.2529 25.2047 15.8436 25.3848 15.3216 25.5127Z",
    fill: "#130F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash3);
export default __webpack_public_path__ + "static/media/dash3.32f84e0a82a9beb8947b931e79b1134b.svg";
export { ForwardRef as ReactComponent };